"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var tv4 = require('tv4');
var TemplateSection = require('./template-section');
var TEMPLATE_STATUS = require('../../constant/procedure/template-status.constant');
var TEMPLATE_TYPES = require('../../constant/procedure/template-type.constant').keys;
var Template = /*#__PURE__*/function () {
  function Template(opt) {
    _classCallCheck(this, Template);
    this._id = new ObjectId();
    this.acknowledgement = {
      showAcknowledgement: false,
      acknowledgeLabel: '',
      prompt: ''
    };
    this.name = null;
    this.types = [];
    this.status = TEMPLATE_STATUS.DRAFT;
    this.sectionDefinitions = [];
    this.maxExpirationDays = null;
    this.tenantCode = [];
    this.campusCode = [];
    this.preventClone = false;
    this.preventRemove = false;
    this.preventShare = false;
    this.preventEditTitle = false;
    this.createBySystem = false;
    this.ruleSet = '';
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(Template, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;
      this._id = new ObjectId(opt._id);
      if (opt.acknowledgement) {
        this.acknowledgement.showAcknowledgement = opt.acknowledgement.showAcknowledgement || this.acknowledgement.showAcknowledgement;
        this.acknowledgement.acknowledgeLabel = opt.acknowledgement.acknowledgeLabel || this.acknowledgement.acknowledgeLabel;
        this.acknowledgement.prompt = opt.acknowledgement.prompt || this.acknowledgement.prompt;
      }
      this.name = opt.name;
      this.types = opt.types || [];
      this.status = opt.status ? opt.status : TEMPLATE_STATUS.DRAFT;
      this.maxExpirationDays = opt.maxExpirationDays ? opt.maxExpirationDays : null;
      this.tenantCode = opt.tenantCode || [];
      this.campusCode = opt.campusCode || [];
      this.preventClone = opt.preventClone || false;
      this.preventRemove = opt.preventRemove || false;
      this.preventShare = opt.preventShare || false;
      this.preventEditTitle = opt.preventEditTitle || false;
      this.createBySystem = opt.createBySystem || false;
      this.ruleSet = opt.ruleSet || 'procedures/default.rules';
      if (opt.sectionDefinitions) {
        opt.sectionDefinitions.forEach(function (definition) {
          return _this.sectionDefinitions.push(new TemplateSection(definition));
        });
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Template.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'template.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          acknowledgement: {
            type: 'object',
            properties: {
              acknowledgeLabel: {
                type: ['null', 'string']
              },
              prompt: {
                type: ['null', 'string']
              },
              showAcknowledgement: {
                type: 'boolean'
              }
            }
          },
          name: {
            type: 'string'
          },
          types: {
            type: 'array',
            items: {
              type: 'string',
              "enum": TEMPLATE_TYPES
            }
          },
          status: {
            type: 'string',
            "enum": Object.keys(TEMPLATE_STATUS)
          },
          maxExpirationDays: {
            type: ['number', 'null']
          },
          sectionDefinitions: {
            type: 'array',
            item: {
              $ref: 'template-section.schema.json'
            }
          },
          tenantCode: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          campusCode: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          preventClone: {
            type: 'boolean'
          },
          preventRemove: {
            type: 'boolean'
          },
          preventShare: {
            type: 'boolean'
          },
          preventEditTitle: {
            type: 'boolean'
          },
          createBySystem: {
            type: 'boolean'
          },
          ruleSet: {
            type: 'string'
          }
        },
        required: Object.keys(this)
      };
    }
  }, {
    key: "clone",
    value: function clone(template, properties) {
      var copy = _objectSpread(_objectSpread({}, template), {}, {
        name: "COPY of ".concat(template.name),
        status: TEMPLATE_STATUS.DRAFT
      }, properties);
      delete copy._id;
      return new this(copy);
    }
  }]);
  return Template;
}();
tv4.addSchema(TemplateSection.schema());
module.exports = Template;